import React from 'react';
import {Box, Grid} from "@material-ui/core";
import {
    ArrivalDatePickerConnected,
    BookSubmitButtonConnected,
    BookWithMilesCheckboxConnected,
    DepartureDatePickerConnected,
    FlightTypeSelectorConnected,
    PassengersCountSelectorConnected,
    PassengerTypeSelectorConnected,
    PromoCodeInputConnected,
    RouteSelectorConnected,
    BookAlertConnected,
    BookMultiCityLegsConnected,
    BookMultiCityAlertConnected,
    BookStopoverConnected,
    useIsStopoverEligibleConnected,
    BookStopoverOpenButtonConnected,
    //BookStopoverWithExperiencesConnected,
} from "../../../index";
import {useSelector} from "react-redux";
import {SW_FLIGHT_TYPES} from "../../../../store/types";

const BookContentFlowConnected = () => {

    const flightType = useSelector(state => state.sw.book.flightType);
    const isStopoverEligible = useIsStopoverEligibleConnected();
    const isStopoverOpen = useSelector(state => state.sw.book.stopover.open);


    if (flightType === SW_FLIGHT_TYPES.MULTI) {
        return (
            <Grid container spacing={2}>
                <Grid xs={12} item>
                    <FlightTypeSelectorConnected/>
                </Grid>
                <BookMultiCityLegsConnected/>
                <BookMultiCityAlertConnected/>
                <Grid xs={12} sm={6} item>
                    <PassengersCountSelectorConnected/>
                </Grid>
                <Grid xs={12} item>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
                        <BookSubmitButtonConnected/>
                    </Box>
                </Grid>
            </Grid>
        );
    }

    //STOPOVER
    if (isStopoverEligible && isStopoverOpen) {
        return (
            <Grid container spacing={2}>
                <Grid xs={12} item>
                    <FlightTypeSelectorConnected/>
                </Grid>
                <Grid xs={12} item>
                    <RouteSelectorConnected/>
                </Grid>
                <Grid xs={12} sm={6} item>
                    <DepartureDatePickerConnected/>
                </Grid>
                <Grid xs={12} sm={6} item>
                    <ArrivalDatePickerConnected/>
                </Grid>
                <Grid xs={12} item>
                    <BookStopoverConnected/>
                </Grid>
                {/*<Grid xs={12} item>
                    <BookStopoverWithExperiencesConnected/>
                </Grid>*/}
            </Grid>
        )
    }

    //COMMON FLOW
    return (
        <Grid container spacing={2}>
            <Grid xs={12} item>
                <FlightTypeSelectorConnected/>
            </Grid>
            <Grid xs={12} item>
                <RouteSelectorConnected/>
            </Grid>
            <Grid xs={12} sm={6} item>
                <DepartureDatePickerConnected/>
            </Grid>
            <Grid xs={12} sm={6} item>
                <ArrivalDatePickerConnected/>
            </Grid>
            <BookStopoverOpenButtonConnected/>
            <Grid xs={12} sm={6} item>
                <PassengersCountSelectorConnected/>
            </Grid>
            <Grid xs={12} sm={6} item>
                <PromoCodeInputConnected/>
            </Grid>
            <BookAlertConnected/>
            <Grid xs={12} sm={8} md={9} item>
                <PassengerTypeSelectorConnected/>
            </Grid>
            <Grid xs={12} sm={4} md={3} item>
                <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                    <BookWithMilesCheckboxConnected/>
                </Box>
            </Grid>
            <Grid xs={12} item>
                <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
                    <BookSubmitButtonConnected/>
                </Box>
            </Grid>
        </Grid>
    );


};

export default BookContentFlowConnected;